module.exports = __webpack_public_path__ + "img/icon_sign.0a9184e5.svg";